import SvgIcon from '@mui/material/SvgIcon';

const DiscordIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M19.54 5.32A17.1 17.1 0 0 0 15.25 4l-.21.41c-.09.18-.18.37-.26.56a15.7 15.7 0 0 0-5.56 0 8.68 8.68 0 0 0-.47-.97c-1.5.25-2.93.69-4.29 1.32C1.75 9.24 1.02 13.07 1.39 16.84A17.35 17.35 0 0 0 6.65 19.5c.43-.58.81-1.2 1.14-1.85-.63-.24-1.23-.53-1.79-.87l.43-.34c3.45 1.6 7.18 1.6 10.59 0l.43.34c-.57.34-1.17.63-1.8.87.33.65.71 1.27 1.14 1.85a17.29 17.29 0 0 0 5.27-2.66c.45-4.37-.77-8.16-2.52-11.52ZM8.53 14.51c-1.03 0-1.87-.95-1.87-2.12s.82-2.12 1.87-2.12c1.04 0 1.89.96 1.87 2.12 0 1.17-.83 2.12-1.87 2.12Zm6.94 0c-1.03 0-1.87-.95-1.87-2.12s.82-2.12 1.87-2.12c1.04 0 1.89.96 1.87 2.12 0 1.17-.83 2.12-1.87 2.12Z" />
  </SvgIcon>
);

export default DiscordIcon;
